<template>
    <div id="hero" class="form-container home-step-2025" :ref="stepName" style="position:relative">
        <div class="hero-icons-wrapper-2025">
            <div class="hero-icons">
                <img src="/images/TA_2025/icons/eur.png" alt="euro icon">
                <p>Proefaanbod</p>
                <p><strong>€2 <br>
                    /2 maanden </strong></p>
            </div>
            <div class="hero-icons">
                <img src="/images/TA_2025/icons/oval-clock.png" alt="euro icon">
                <p>Abonnement </p>
                <p> <strong>opzegbaar op
                    ieder moment</strong> </p>
            </div>
        </div>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
        <hr>
    </div>

</template>

<script>
import mixin from "../../../travel_step_mixin";

export default {
    mixins: [mixin],
}
</script>

